<template>
  <div class="final-winner">
    <div class="final-winner__title">Победитель</div>
    <div class="final-winner__value"><slot /></div>
  </div>
</template>

<script>
export default {
  name: "BracketFinalWinner"
};
</script>

<style lang="scss">
.final-winner {
  text-transform: uppercase;
  width: 220px;
  text-align: center;
  font-weight: bold;
  font-size: 24px;

  &__title,
  &__value {
    border-radius: 4px;
    height: 40px;
    line-height: 40px;
    width: 100%;
    padding: 0 5px;
  }

  &__title {
    color: colors(text-4);
    background-color: colors(palette-1);
    margin-bottom: 4px;
  }

  &__value {
    color: colors(text-3);
    background-color: colors(palette-4);
    display: inline-block;
    @include text-ellipsis();
  }
}
</style>
